var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 82,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1292 46.1439L63.2111 73.0715L90.1292 99.9992H59.3698L32.4421 73.0715L59.3698 46.1439H90.1292ZM59.3698 0L9.375 49.9948L24.7595 65.3793L90.1292 0H59.3698Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4512 73.0717L47.826 88.4562L90.1286 46.144H59.3692L32.4512 73.0717Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_166_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 82,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1292 46.1439L63.2111 73.0715L90.1292 99.9992H59.3698L32.4421 73.0715L59.3698 46.1439H90.1292ZM59.3698 0L9.375 49.9948L24.7595 65.3793L90.1292 0H59.3698Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_166_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3698 0H90.1292L24.7595 65.3793L9.375 49.9948L59.3698 0Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_166_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 82,
    height: 100
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1292 46.1439L63.2111 73.0715L90.1292 99.9992H59.3698L32.4421 73.0715L59.3698 46.1439H90.1292ZM59.3698 0L9.375 49.9948L24.7595 65.3793L90.1292 0H59.3698Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_166_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8262 88.4563L59.3694 99.9898H90.1287L63.2107 73.0718L47.8262 88.4563Z",
    fill: "#03569B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_166_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 82,
    height: 100
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1292 46.1439L63.2111 73.0715L90.1292 99.9992H59.3698L32.4421 73.0715L59.3698 46.1439H90.1292ZM59.3698 0L9.375 49.9948L24.7595 65.3793L90.1292 0H59.3698Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_166_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.643 80.5522L63.2107 73.0718L47.8262 88.4563L70.643 80.5522Z",
    fill: "url(#paint0_linear_166_133)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_166_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 82,
    height: 100
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1292 46.1439L63.2111 73.0715L90.1292 99.9992H59.3698L32.4421 73.0715L59.3698 46.1439H90.1292ZM59.3698 0L9.375 49.9948L24.7595 65.3793L90.1292 0H59.3698Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_166_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4492 73.0661L47.8341 57.6812L63.2199 73.0661L47.8341 88.4511L32.4492 73.0661Z",
    fill: "#16B9FD"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1292 46.1439L63.2111 73.0715L90.1292 99.9992H59.3698L32.4421 73.0715L59.3698 46.1439H90.1292ZM59.3698 0L9.375 49.9948L24.7595 65.3793L90.1292 0H59.3698Z",
    fill: "url(#paint1_radial_166_133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_133",
    x1: 52.3159,
    y1: 91.4252,
    x2: 63.7739,
    y2: 79.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_166_133",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6437 6.81566) scale(122.337 122.337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/Flutter.9be7e44247cb749f7d2912444006a1b2.svg";
export { ForwardRef as ReactComponent };